export default [
  { id: 1, content: "Make things happen", completed: false },
  { id: 2, content: "Make a to-do list", completed: true },
  { id: 3, content: "Buy a unicorn", completed: false }
];
